import React, { useEffect } from "react";
import img2 from "../assets/smart_dustbin_dashboard.png";
import Footer from "../components/Footer";


const SmartDustbinMonitoringSystem = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="App">
            <div className="container py-5 main-content" style={{ marginTop: "50px" }}>
                <h1>Smart Dustbin Monitoring System</h1>


                <p className="lead">
                    <strong>Smart Dustbin Monitoring System</strong> is a retrofit sensor-based module that upgrades existing
                    dustbins with smart level monitoring.
                    It uses laser-based sensing to measure the waste fill level (e.g., 25%, 50%, 75%, 100%) and
                    automatically sends the status to a centralized cloud platform or mobile dashboard.
                    This enables timely waste collection, prevents overflow, and enhances hygiene management —
                    ideal for airports, malls, corporate parks, and municipalities.
                </p>

                <div className="row my-4">
                    <div className="col-md-12 mb-5 d-flex justify-content-center">
                        <div className="img-card h-100 d-flex align-items-center justify-content-center">
                            <img
                                src={img2}
                                alt="Smart Dustbin Monitoring System Image"
                                className="img-fluid rounded shadow"
                                style={{ maxHeight: "400px", objectFit: "contain" }}
                            />
                        </div>
                    </div>
                </div>
                <style>{`
                        .img-card {
                            background: #f8fafc;
                            border: 1px solid #e3e8ee;
                            border-radius: 16px;
                            padding: 24px;
                            box-shadow: 0 4px 24px rgba(25, 118, 210, 0.07);
                            transition: box-shadow 0.2s, transform 0.2s;
                            min-height: 260px;
                        }
                        .img-card:hover {
                            box-shadow: 0 8px 32px rgba(25, 118, 210, 0.15);
                            transform: translateY(-4px) scale(1.02);
                        }
                `}</style>


            </div>
            <Footer />
        </div>
    );
};

export default SmartDustbinMonitoringSystem;
